import { Spinner } from "react-bootstrap";

export const HotelBookLoading = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "rgba(255,255,255,0.85)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Spinner
        animation="border"
        role="status"
        style={{ color: "#0ab39c", width: "3rem", height: "3rem" }}
      />
      <p
        className="mt-3 text-muted"
        style={{ maxWidth: "400px", fontSize: "1.1rem" }}
      >
        Please do not close or reload this page while your request is being
        processed.
      </p>
    </div>
  );
};
